export default function MobileStickyCta() {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-50 border-t border-background-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <div className="flex items-center gap-2 px-4 py-3 max-w-lg mx-auto">
        <a
          href="tel:010-2833-1395"
          className="flex-1 flex items-center justify-center gap-2 bg-primary-500 text-background-50 py-3 rounded-md text-sm font-bold hover:bg-primary-600 transition-colors"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-phone-line text-xs"></i>
          </span>
          전화 상담
        </a>
        <a
          href="https://m.booking.naver.com/booking/6/bizes/1236562?theme=place&entry=pll&lang=ko"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="flex-1 flex items-center justify-center gap-2 bg-secondary-500 text-background-50 py-3 rounded-md text-sm font-bold hover:bg-secondary-600 transition-colors"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-calendar-check-line text-xs"></i>
          </span>
          네이버 예약
        </a>
      </div>
    </div>
  );
}